import Link from "next/link";
import { useCartTotalItems } from "src/hooks/stores/use-cart-store";
import { ShoppingCart } from "src/icons";
import { Badge } from "src/atoms/Badge";
import styles from "./Header.module.scss";

function CartButton(): JSX.Element {
  const totalItems = useCartTotalItems();

  return (
    <Link
      className={styles.navigationLink}
      href="/cart"
      prefetch={false}
      data-testid="main-header-cart-a"
    >
      <ShoppingCart width="22" height="24" />
      {totalItems > 0 && (
        <Badge
          className={styles.cartCount}
          data-testid="main-header-cart-counter"
        >
          {totalItems}
        </Badge>
      )}
    </Link>
  );
}

export { CartButton };
